(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isNewsletterMenu = this.querySelector('#footer-signup_form') !== null;

        // Desktop: all footer menus stay open.
        // Mobile: newsletter stays open by default; other menus stay collapsed.
        this.disclosure.open = isLargeScreen || isNewsletterMenu;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      /**
       * Newsletter panel contains an inset-shadow input. JS height animation
       * clips it into a visible horizontal bar — use native <details> instead.
       */
      checkTransitionsEnabled() {
        if (this.querySelector('#footer-signup_form') !== null) {
          this.transitionsEnabled = false;
          return;
        }
        this.transitionsEnabled = window.getComputedStyle(this.panel).transitionDuration !== '0s';
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
